import { EditorClass } from "luxedo-canvas"
import { MaskBase } from "luxedo-canvas/asset"
import { CalibratedMask, DataHandlerMask, MaskBaseJson, Snapshot } from "luxedo-data"
import { MaskRepository } from "luxedo-image-modifier"

export class ImageModifyMaskRepo implements MaskRepository {
	calibrationId: number
	editor: EditorClass

	constructor(editor: EditorClass, snapshot: Snapshot) {
		this.calibrationId = snapshot.cal_id
		this.editor = editor
	}

	async listAll(): Promise<MaskBase[]> {
		const calMasks = DataHandlerMask.filterByCalibration(this.calibrationId)
		const baseMasks = []

		for (const mask of calMasks) {
			const base = await this.loadMask(mask)
			baseMasks.push(base)
		}

		return baseMasks.reverse()
	}

	async refresh(): Promise<void> {
		await DataHandlerMask.pull()
	}

	async save(mask: MaskBase): Promise<MaskBase> {
		const data: MaskBaseJson = mask.serialize(true) as MaskBaseJson
		data["pathData"] = mask.path.serialize(true)

		let maskId
		if (data["entryId"]) {
			const maskEntry = DataHandlerMask.get(data.entryId)
			maskId = maskEntry.id
			maskEntry.name = data.name
			maskEntry.mask_json = data
			await DataHandlerMask.save(maskEntry)
		} else {
			maskId = await DataHandlerMask.createEntry({
				name: mask.name,
				cal_id: this.calibrationId,
				mask_json: JSON.stringify(data),
			})
		}
		await DataHandlerMask.pull([maskId])
		return this.loadMask(DataHandlerMask.get(maskId))
	}

	private async loadMask(mask: CalibratedMask) {
		if (mask.importPromise) await mask.importPromise

		let base: MaskBase
		if (mask.mask_json.__CONSTRUCTOR__ === "ClippingMask") {
			// @ts-ignore
			const clipMask = await ClippingMask.loadJSON(Editor, mask.mask_json)
			base = await MaskBase.fromClippingMask(clipMask)
		} else {
			base = await MaskBase.loadJSON(this.editor, mask.mask_json)
		}

		return base
	}
}
